import { render, staticRenderFns } from "./MedicoSearch.vue?vue&type=template&id=06467ce5&scoped=true"
import script from "./MedicoSearch.vue?vue&type=script&lang=js"
export * from "./MedicoSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06467ce5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/vercel/path0/components/elements/Section.vue').default})
